import { Localized } from "@fluent/react";
import { Alert, AlertTitle, Button, Card, CardContent, Skeleton, Typography } from "@mui/material";
import { Invite } from "../../types/apiv1";

export enum InviteError {
	NotFound = "not-found",
	Forbidden = "forbidden",
	Network = "network",
	Bug = "bug",
}

export type InviteCardProps = {
	loadError: InviteError | null,
	acceptError: InviteError | null,
	invite: Invite | null,
	onAccept: () => void,
};

export default function InviteCard(props: InviteCardProps) {
	return <Card>
		{props.loadError &&
			<Alert severity="error" sx={{ borderRadius: '0' }}>
				<Localized id="invite-load-error-title"><AlertTitle /></Localized>
				<Localized id={`invite-error-${props.loadError}`} />
			</Alert>
		}
		{props.acceptError &&
			<Alert severity="error" sx={{ borderRadius: '0' }}>
				<Localized id="invite-accept-error-title"><AlertTitle /></Localized>
				<Localized id={`invite-error-${props.acceptError}`} />
			</Alert>
		}
		<CardContent sx={{ paddingTop: '32px' }}>
			<Localized id="invite-title">
				<Typography variant="h5" align="center" color="text.secondary" />
			</Localized>
			<Typography variant="h4" align="center">
				{props.invite
					? props.invite.organization.name
					: <Skeleton sx={{ transform: 'scale(1, 0.9)', maxWidth: '300px', margin: '0 auto' }} />}
			</Typography>
			{props.invite
				? <Localized id="invite-accept-button">
					<Button
						color="success"
						variant="contained"
						sx={{ display: 'block', margin: '16px auto' }}
						onClick={props.onAccept}
					/>
				</Localized>
			: <Skeleton variant="rounded" width={100} height={36.5} sx={{ margin: '16px auto'}} />}
		</CardContent>
	</Card>
}
